import React from 'react';
import './Room.css';
import { colors, Typography } from 'kangarootime-ui';

const Room = ({ room: { roomId, roomName, percentage }, selectRoom }) => {
  const formatPercentage = num => (isNaN(num) || num === null) ? 0 : parseFloat(parseFloat(num) * 100).toFixed(0);

  const statusColor = num => {
    const formattedInteger = parseInt(formatPercentage(num), 10);

    if (formattedInteger < 0) {
      return colors.warning;
    } else if (formattedInteger <= 30) {
      return colors.danger;
    } else if (formattedInteger <= 55) {
      return colors.salmon;
    } else if (formattedInteger <= 70) {
      return colors.warning;
    } else {
      return colors.success;
    }
  };

  return (
    <div className='roomGalleryMetricCard' onClick={() => selectRoom(roomId)}>
      <Typography type='header' style={{ textAlign: 'center', marginTop: 12, color: statusColor(percentage) }}>{formatPercentage(percentage)}%</Typography>
      <div className='flex-1' style={{ backgroundColor: '#000000', marginTop: 12, justifyContent: 'center', overflow: 'hidden' }}>
        <Typography style={{ textAlign: 'center', color: colors.white, fontSize: '1rem', textOverflow: 'ellipsis' }}>{roomName}</Typography>
      </div>
    </div>
  );
};

export default Room;
